import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { Children, cloneElement } from 'react';
import moment from 'moment';
import { EmbersDateSelect } from '../../../../date';
import { EmbersMiniSelect } from '../../../../select/miniSelect/miniSelect';
export var getDateOption = function getDateOption(range, codeKey, labelKey, dateFormatString) {
  var _ref;
  if (!(range !== null && range !== void 0 && range.from)) return {};
  var dateFormat = dateFormatString || moment.localeData('en').longDateFormat('LL');
  var from = range.from ? moment(range.from).format(dateFormat) : undefined;
  var to = range.to ? moment(range.to).format(dateFormat) : undefined;
  var label = from === to ? from : "".concat(from, "-").concat(to);
  return _ref = {}, _defineProperty(_ref, labelKey, label), _defineProperty(_ref, codeKey, label), _ref;
};
export var getOption = function getOption(option, codeKey, labelKey) {
  var _ref2;
  if (!option) return {};
  return _typeof(option) === 'object' ? option : (_ref2 = {}, _defineProperty(_ref2, codeKey, option), _defineProperty(_ref2, labelKey, option), _ref2);
};
export var isDateEle = function isDateEle(child) {
  return child.type === EmbersDateSelect;
};
export var isArrayEqual = function isArrayEqual(codeKey, a, b) {
  if (a.length !== b.length) {
    return false;
  }
  var unionSize = new Set([].concat(_toConsumableArray(a.map(function (o) {
    return "".concat(o.filterName, "-").concat(o[codeKey]);
  })), _toConsumableArray(b.map(function (o) {
    return "".concat(o.filterName, "-").concat(o[codeKey]);
  })))).size;
  if (unionSize !== a.length || unionSize !== b.length) {
    return false;
  }
  return true;
};
export var getValueProps = function getValueProps(filtersValue, child) {
  var data = filtersValue[child.props.name];
  return data ? isDateEle(child) ? {
    value: data.value,
    selection: data.selection
  } : {
    value: data
  } : {};
};
export var getRemovedValueByCode = function getRemovedValueByCode(array, code, codeKey) {
  var index = array.findIndex(function (item) {
    if (_typeof(item) === 'object') {
      return item[codeKey] === code;
    }
    return item === code;
  });
  return index > -1 ? [].concat(_toConsumableArray(array.slice(0, index)), _toConsumableArray(array.slice(index + 1, array.length))) : array;
};
export var cloneFilters = function cloneFilters(children, getChildProps) {
  return Children.map(children || [], function (child) {
    if (child.type !== EmbersMiniSelect && child.type !== EmbersDateSelect) throw new Error('FiltersDecorator prop children only support MiniSelect or Date Component');
    var type = '';
    if (child.type === EmbersDateSelect) {
      type = 'date';
    } else if (child.type === EmbersMiniSelect) {
      if (child.props.multiple) {
        type = 'multiple';
      } else {
        type = 'single';
      }
    }
    if (type) {
      var childProps = getChildProps(child, type);
      if (childProps) {
        return /*#__PURE__*/cloneElement(child, childProps);
      }
    }
    return null;
  });
};